import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
import { v_DispatchNoteBus } from "./v_DispatchNoteBus";

export class DispatchCallbackBus extends BaseBus{
   
    constructor(busObj: DispatchCallbackBus) {
        super(busObj);
        if (busObj) {
            this.receivedDateTime = CommonFunctions.getDate(busObj.receivedDateTime);
            this.cbReceivedDateTime = CommonFunctions.getDate(busObj.cbReceivedDateTime);
        }
    }
    CID(): any {
        return this.dispatchId;
    }

    dispatchNumber: string;
    cbDispatchNumber: string;
    receivedDateTime: Date;
    cbReceivedDateTime: Date;
    assigned: string;
    cbAssigned: string;
    dispatchReason: string;
    cbDispatchReason: string;
    systemIds: string;
    cbSystemIds: string;
    woNumber: string;
    firstTechAssigned: string;
    firstTechAssignedId: any;
    dispatchId: any;
    callbackId: any;
    callbackSystemIdNote: string;
    notes: v_DispatchNoteBus[];
    cbNotes: v_DispatchNoteBus[];
}